'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clean = clean;
var PREFIX = '@@redux-saga-thunk/';

var CLEAN = exports.CLEAN = PREFIX + 'clean';

/**
 * Clean state
 * @example
 * const mapDispatchToProps = (dispatch, ownProps) => ({
 *   cleanFetchUserStateForAllIds: () => dispatch(clean('FETCH_USER')),
 *   cleanFetchUserStateForSpecifiedId: () => dispatch(clean('FETCH_USER', ownProps.id)),
 *   cleanFetchUsersState: () => dispatch(clean('FETCH_USERS')),
 * })
 */
// eslint-disable-next-line import/prefer-default-export
function clean(name, id) {
  return {
    type: CLEAN,
    meta: {
      thunk: arguments.length > 1 ? { name: name, id: id } : { name: name }
    }
  };
}